import { InfiniteData } from '@tanstack/react-query'

import { Ticket, TicketsResponse, TicketsResponseOneOf } from 'types'

export const unpackTicketsResponsePages = (
  ticketPages: InfiniteData<TicketsResponse>,
): TicketsResponse => {
  if ('items' in ticketPages.pages[0]) {
    return {
      count: ticketPages.pages[0]?.count,
      items: ticketPages.pages.map(page => (page as TicketsResponseOneOf).items).flat(),
    } as TicketsResponseOneOf
  }

  return (ticketPages.pages as Ticket[][]).flat()
}
